/**
 * CaseManageSlice Document Request Reducers
 * 
 * Reducers for managing document request details on cases.
 */

import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { DocumentRequestView } from '../../types/caseManageTypes';
import { CaseManageSliceState } from '../state';

// =============================================================================
// DOCUMENT REQUEST REDUCERS
// =============================================================================

/**
 * Update document request details
 */
export const updateDocumentRequest: CaseReducer<
  CaseManageSliceState,
  PayloadAction<Partial<DocumentRequestView>>
> = (state, action) => {
  if (state.currentCase) {
    state.currentCase.documentRequest = {
      ...state.currentCase.documentRequest,
      ...action.payload,
    };
    state.isEdited = true;
    if (!state.editedFields.includes('documentRequest')) {
      state.editedFields.push('documentRequest');
    }
  }
};
